// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store-link-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.store-wrapper {
  width: 58.233375vw;
  margin: auto;
  position: relative;
  top: 1.45vw;
}

.quiz-container {
  width: 58.24vw;
  margin: auto;
}
.quiz-container .MuiFormHelperText-root.Mui-error {
  font-size: 11px;
  margin: 0.25rem;
  color: rgba(238, 58, 36, 0.8) !important;
}

.env-store-add-product-heading {
  margin-left: 1.83vw;
  margin-bottom: 1.65vw;
}

.env-store-add-product-heading h2 {
  font-weight: 400;
  line-height: 2.08125vw;
  letter-spacing: -2%;
  font-size: 2.08125vw;
}

.stepper {
  display: flex;
  align-content: center;
  flex: 1 1;
  justify-content: space-between;
}

.round.active {
  background: #ee3a24;
  color: #fff;
}

.round a {
  color: #ee3a24;
}

.round.step-not-active {
  border: 0.027vw solid #ee3a24;
  background-color: #F7F1FF;
}

.round {
  background: rgba(238, 58, 36, 0.1803921569);
  position: relative;
  width: 2.22vw;
  height: 2.22vw;
  line-height: 2.22vw;
  border-radius: 100%;
  color: #ee3a24;
  text-align: center;
}

.round::after {
  content: " ";
  display: block;
  margin-top: -1.24875vw;
  margin-right: 0;
  bottom: 0.069375vw;
  margin-left: 0.485625vw;
  height: 0.069375vw;
  width: 0.069375vw;
  transform: scale(87, 1);
  transform-origin: -30% 0;
  background-color: rgba(238, 58, 36, 0.1803921569);
  z-index: -1;
}

.round:nth-child(5):after {
  content: " ";
  display: none;
}

.submit-btn button:disabled {
  background-color: transparent;
  border: 0.03vw solid #939393;
  color: #939393;
  cursor: default;
}

.submit-btn button:disabled path {
  stroke: #939393;
}

.inner-quiz-container {
  background-color: rgba(255, 255, 255, 0.8980392157);
  width: calc(100% - 17.35vw);
  margin: auto;
  border-radius: 0.21vw;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  padding: 2.775vw 4.44vw;
  text-align: left;
}

.inner-container {
  background-color: rgba(255, 255, 255, 0.8980392157);
  width: auto;
  border-radius: 0.21vw;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  padding: 2.775vw 4.44vw;
}
.inner-container .spinner-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.inner-container .spinner-wrapper .spinner {
  position: fixed;
  top: 50%;
}

.inner-game-container {
  background-color: rgba(255, 255, 255, 0.8980392157);
  margin: auto;
  border-radius: 0.21vw;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  padding: 4rem;
}

.inner-quiz-game-container {
  background-color: rgba(255, 255, 255, 0.8980392157);
  margin: auto;
  border-radius: 0.21vw;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  padding: 2.22vw;
}

.store-heading {
  text-align: center;
}

.store-heading h2 {
  font-weight: 400;
  font-size: 2.08125vw;
  color: #3a3a3a;
  line-height: 2.08125vw;
  letter-spacing: -2%;
  text-align: center;
  margin-top: 1.11vw;
}

.store-heading p {
  font-size: 1.040625vw;
  font-weight: 500;
  color: #ee3a24;
  line-height: 1.24875vw;
  letter-spacing: -2%;
}

.store-text p {
  font-size: 1.040625vw;
  font-weight: 500;
  line-height: 1.24875vw;
  letter-spacing: 2%;
  margin: 2.22vw 0;
}

.env-input-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.env-input-container label {
  font-weight: 400;
  font-size: 0.901875vw;
  line-height: 1.24875vw;
  color: #616161;
}

.env-input-container input {
  width: 100%;
  margin: 0.555vw 0 0.555vw 0.555vw;
  padding: 1.11vw 0.555vw;
  background: rgba(255, 255, 255, 0.8980392157);
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
}

.env-input-container .info-icon {
  position: relative;
  right: 2.22vw;
}

.env-input-container .link-icon {
  position: relative;
  left: 2.775vw;
}

.env-url-wrapper {
  display: flex;
  align-items: center;
}
.env-url-wrapper .MuiTextField-root {
  width: 100%;
  background-color: #fff;
  border: none;
  box-shadow: none !important;
}
.env-url-wrapper .MuiInputBase-root {
  box-shadow: none;
}
.env-url-wrapper input {
  padding: 0.9325vw 0.555vw;
}

.env-url-wrapper label {
  margin-right: 1.11vw;
  font-size: 0.903vw;
  font-weight: 400;
  line-height: 1.25vw;
  color: #616161;
}

.agree-check {
  text-align: left;
  margin: 2.22vw 0;
  display: flex;
  align-items: center;
}

input[type=checkbox] {
  width: 1.3875vw; /*Desired width*/
  height: 1.3875vw; /*Desired height*/
  cursor: pointer;
}

input[type=checkbox]:checked {
  accent-color: #ee3a24;
}

.agree-check span {
  font-weight: 400;
  font-size: 0.901875vw;
  line-height: 1.24875vw;
  letter-spacing: 2%;
  margin: 0 0.555vw;
}

.submit-btn {
  margin: 1.11vw 0;
  text-align: center;
}

.submit-btn button {
  font-weight: 500;
  font-size: 0.901875vw;
  background-color: #ee3a24;
  border-radius: 0.21vw;
  padding: 1.11vw 2.775vw;
  border: none;
  color: #fff;
  cursor: pointer;
  line-height: 1.24875vw;
}

.submit-btn button span {
  margin: 0 0.25rem;
}

.env-url-wrapper .MuiInputBase-root fieldset.MuiOutlinedInput-notchedOutline,
.env-url-wrapper .MuiInputBase-root:hover fieldset.MuiOutlinedInput-notchedOutline {
  border: 1px solid #ababab;
}

.css-1eex93v-MuiTooltip-tooltip {
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.1215686275);
  background-color: #fff !important;
  color: #000 !important;
  padding: 8px !important;
}

.css-iglfhh-MuiTooltip-arrow {
  color: #Fff !important;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.1215686275) !important;
}

@media only screen and (min-width: 601px) {
  .stepper {
    flex: 0 1;
    justify-content: flex-start;
  }
  .round {
    position: relative;
    margin: 0 0 0 54px;
    left: -52px;
  }
  .round::after {
    content: " ";
    display: block;
    margin-top: -1.24875vw;
    margin-right: 0;
    bottom: 1px;
    margin-left: 17px;
    height: 1px;
    width: 1px;
    transform: scale(55, 1);
    transform-origin: -30% 0;
    background-color: rgba(238, 58, 36, 0.1803921569);
  }
}`, "",{"version":3,"sources":["webpack://./src/style/components/store/EnvStore.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AACF;;AACA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAEF;;AAAA;EACE,cAAA;EACA,YAAA;AAGF;AAFE;EACE,eAAA;EACA,eAAA;EACA,wCAAA;AAIJ;;AADA;EACE,mBAAA;EACA,qBAAA;AAIF;;AAFA;EACE,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AAKF;;AAHA;EAEE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,8BAAA;AAKF;;AAHA;EACE,mBAAA;EACA,WAAA;AAMF;;AAJA;EACE,cAAA;AAOF;;AALA;EACE,6BAAA;EACA,yBAAA;AAQF;;AANA;EACE,2CAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AASF;;AAPA;EACE,YAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,wBAAA;EACA,iDAAA;EACA,WAAA;AAUF;;AARA;EACE,YAAA;EACA,aAAA;AAWF;;AARA;EACE,6BAAA;EACA,4BAAA;EACA,cAAA;EACA,eAAA;AAWF;;AATA;EACE,eAAA;AAYF;;AATA;EACE,mDAAA;EACA,2BAAA;EACA,YAAA;EACA,qBAAA;EACA,+DAAA;EACA,uBAAA;EACA,gBAAA;AAYF;;AAVA;EACE,mDAAA;EACA,WAAA;EACA,qBAAA;EAEA,+DAAA;EAEA,uBAAA;AAWF;AAVE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAYJ;AAXI;EACE,eAAA;EACA,QAAA;AAaN;;AARA;EACE,mDAAA;EAEA,YAAA;EACA,qBAAA;EACA,+DAAA;EACA,aAAA;AAUF;;AARA;EACE,mDAAA;EACA,YAAA;EACA,qBAAA;EACA,+DAAA;EACA,eAAA;AAWF;;AATA;EACE,kBAAA;AAYF;;AAVA;EACE,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAaF;;AAXA;EACE,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AAcF;;AAZA;EACE,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAeF;;AAbA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAgBF;;AAdA;EACE,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;AAiBF;;AAfA;EACE,WAAA;EACA,iCAAA;EACA,uBAAA;EACA,6CAAA;EACA,+DAAA;AAkBF;;AAfA;EACE,kBAAA;EACA,aAAA;AAkBF;;AAhBA;EACE,kBAAA;EACA,aAAA;AAmBF;;AAjBA;EACE,aAAA;EACA,mBAAA;AAoBF;AAnBE;EACE,WAAA;EACA,sBAAA;EACA,YAAA;EACA,2BAAA;AAqBJ;AAnBE;EAEE,gBAAA;AAoBJ;AAlBE;EACE,yBAAA;AAoBJ;;AAhBA;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAmBF;;AAjBA;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAoBF;;AAlBA;EACE,eAAA,EAAA,gBAAA;EACA,gBAAA,EAAA,iBAAA;EACA,eAAA;AAqBF;;AAnBA;EACE,qBAAA;AAsBF;;AApBA;EACE,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AAuBF;;AArBA;EACE,gBAAA;EACA,kBAAA;AAwBF;;AArBA;EACE,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AAwBF;;AArBA;EACE,iBAAA;AAwBF;;AAtBA;;EAIE,yBAAA;AAuBF;;AAnBA;EACE,uDAAA;EACA,iCAAA;EACA,sBAAA;EACA,uBAAA;AAsBF;;AAnBA;EACE,sBAAA;EACA,kEAAA;AAsBF;;AA8IA;EACE;IACE,SAAA;IACA,2BAAA;EA3IF;EA6IA;IACE,kBAAA;IACA,kBAAA;IACA,WAAA;EA3IF;EA6IA;IACE,YAAA;IACA,cAAA;IACA,sBAAA;IACA,eAAA;IACA,WAAA;IACA,iBAAA;IACA,WAAA;IACA,UAAA;IACA,uBAAA;IACA,wBAAA;IACA,iDAAA;EA3IF;AACF","sourcesContent":[".store-link-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.store-wrapper {\n  width: 58.233375vw;\n  margin: auto;\n  position: relative;\n  top: 1.45vw;\n}\n.quiz-container {\n  width: 58.24vw;\n  margin: auto;\n  .MuiFormHelperText-root.Mui-error {\n    font-size: 11px;\n    margin: 0.25rem;\n    color: #ee3a24cc !important;\n  }\n}\n.env-store-add-product-heading {\n  margin-left: 1.83vw;\n  margin-bottom: 1.65vw;\n}\n.env-store-add-product-heading h2 {\n  font-weight: 400;\n  line-height: 2.08125vw;\n  letter-spacing: -2%;\n  font-size: 2.08125vw;\n}\n.stepper {\n  // width: fit-content;\n  display: flex;\n  align-content: center;\n  flex: 1 1;\n  justify-content: space-between;\n}\n.round.active {\n  background: #ee3a24;\n  color: #fff;\n}\n.round a {\n  color: #ee3a24;\n}\n.round.step-not-active {\n  border: 0.027vw solid #ee3a24;\n  background-color: #F7F1FF;\n}\n.round {\n  background: #ee3a242e;\n  position: relative;\n  width: 2.22vw;\n  height: 2.22vw;\n  line-height: 2.22vw;\n  border-radius: 100%;\n  color: #ee3a24;\n  text-align: center;\n}\n.round::after {\n  content: \" \";\n  display: block;\n  margin-top: -1.24875vw;\n  margin-right: 0;\n  bottom: 0.069375vw;\n  margin-left: 0.485625vw;\n  height: 0.069375vw;\n  width: 0.069375vw;\n  transform: scale(87, 1);\n  transform-origin: -30% 0;\n  background-color: #ee3a242e;\n  z-index: -1;\n}\n.round:nth-child(5):after {\n  content: \" \";\n  display: none;\n}\n\n.submit-btn button:disabled {\n  background-color: transparent;\n  border: 0.03vw solid #939393;\n  color: #939393;\n  cursor: default;\n}\n.submit-btn button:disabled path {\n  stroke: #939393;\n}\n\n.inner-quiz-container {\n  background-color: #ffffffe5;\n  width: calc(100% - 17.35vw);\n  margin: auto;\n  border-radius: 0.21vw;\n  box-shadow: 0px 4px 7.4px 0px #bebebe40;\n  padding: 2.775vw 4.44vw;\n  text-align: left;\n}\n.inner-container {\n  background-color: #ffffffe5;\n  width: auto;\n  border-radius: 0.21vw;\n  // box-shadow: 0 0 0 0.21vw #BEBEBE40;\n  box-shadow: 0px 4px 7.4px 0px #bebebe40;\n\n  padding: 2.775vw 4.44vw;\n  .spinner-wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .spinner {\n      position: fixed;\n      top: 50%;\n    }\n  }\n  // text-align: center;\n}\n.inner-game-container {\n  background-color: #ffffffe5;\n  // width: 100%;\n  margin: auto;\n  border-radius: 0.21vw;\n  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n  padding: 4rem;\n}\n.inner-quiz-game-container {\n  background-color: #ffffffe5;\n  margin: auto;\n  border-radius: 0.21vw;\n  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n  padding: 2.22vw;\n}\n.store-heading {\n  text-align: center;\n}\n.store-heading h2 {\n  font-weight: 400;\n  font-size: 2.08125vw;\n  color: #3a3a3a;\n  line-height: 2.08125vw;\n  letter-spacing: -2%;\n  text-align: center;\n  margin-top: 1.11vw;\n}\n.store-heading p {\n  font-size: 1.040625vw;\n  font-weight: 500;\n  color: #ee3a24;\n  line-height: 1.24875vw;\n  letter-spacing: -2%;\n}\n.store-text p {\n  font-size: 1.040625vw;\n  font-weight: 500;\n  line-height: 1.24875vw;\n  letter-spacing: 2%;\n  margin: 2.22vw 0;\n}\n.env-input-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.env-input-container label {\n  font-weight: 400;\n  font-size: 0.901875vw;\n  line-height: 1.24875vw;\n  color: #616161;\n}\n.env-input-container input {\n  width: 100%;\n  margin: 0.555vw 0 0.555vw 0.555vw;\n  padding: 1.11vw 0.555vw;\n  background: #ffffffe5;\n  box-shadow: 0px 4px 7.4px 0px #bebebe40;\n}\n\n.env-input-container .info-icon {\n  position: relative;\n  right: 2.22vw;\n}\n.env-input-container .link-icon {\n  position: relative;\n  left: 2.775vw;\n}\n.env-url-wrapper {\n  display: flex;\n  align-items: center;\n  .MuiTextField-root {\n    width: 100%;\n    background-color: #fff;\n    border: none;\n    box-shadow: none !important;\n  }\n  .MuiInputBase-root {\n    // border: 1px solid #ABABAB;\n    box-shadow: none;\n  }\n  input {\n    padding: 0.9325vw 0.555vw;\n    // border: none;\n  }\n}\n.env-url-wrapper label {\n  margin-right: 1.11vw;\n  font-size: 0.903vw;\n  font-weight: 400;\n  line-height: 1.25vw;\n  color: #616161;\n}\n.agree-check {\n  text-align: left;\n  margin: 2.22vw 0;\n  display: flex;\n  align-items: center;\n}\ninput[type=\"checkbox\"] {\n  width: 1.3875vw; /*Desired width*/\n  height: 1.3875vw; /*Desired height*/\n  cursor: pointer;\n}\ninput[type=\"checkbox\"]:checked {\n  accent-color: #ee3a24;\n}\n.agree-check span {\n  font-weight: 400;\n  font-size: 0.901875vw;\n  line-height: 1.24875vw;\n  letter-spacing: 2%;\n  margin: 0 0.555vw;\n}\n.submit-btn {\n  margin: 1.11vw 0;\n  text-align: center;\n}\n\n.submit-btn button {\n  font-weight: 500;\n  font-size: 0.901875vw;\n  background-color: #ee3a24;\n  border-radius: 0.21vw;\n  padding: 1.11vw 2.775vw;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  line-height: 1.24875vw;\n}\n\n.submit-btn button span {\n  margin: 0 0.25rem;\n}\n.env-url-wrapper .MuiInputBase-root fieldset.MuiOutlinedInput-notchedOutline,\n.env-url-wrapper\n  .MuiInputBase-root:hover\n  fieldset.MuiOutlinedInput-notchedOutline {\n  border: 1px solid #ababab;\n}\n\n//tooltip css\n.css-1eex93v-MuiTooltip-tooltip {\n  box-shadow: 0px 2px 7px 0px #0000001F;\n  background-color: #fff!important;\n  color: #000!important;\n  padding: 8px!important;\n}\n\n.css-iglfhh-MuiTooltip-arrow {\n  color: #Fff!important;\n  box-shadow: 0px 2px 7px 0px #0000001F!important;\n}\n\n// @media only screen and (min-width: 300px) {\n//   .submit-btn{\n//       text-align: center;\n//   }\n//   .submit-btn button {\n//       padding: 0.75rem 0.5rem;\n//      }\n// }\n// @media only screen and (max-width: 475px) {\n//   .inner-container, .inner-game-container{\n//       text-align: left;\n//       padding: 2.5rem 1.5rem;\n//   }\n// }\n// @media only screen and (max-width: 335px) {\n//   .env-store-add-product-heading{\n//     margin-left: 1rem;\n// }\n//   .round::after{\n//     content: \" \";\n//     display: block;\n//     margin-top: -18px;\n//     margin-right: 0;\n//     bottom: 1px;\n//     margin-left: 26px;\n//     height: 1px;\n//     width: 1px;\n//     transform: scale(11, 1);\n//     transform-origin: -36% 0;\n//     background-color: rgba(238, 58, 36, 0.1803921569);\n\n//   }\n// }\n\n// @media only screen and (min-width: 336px) and  (max-width: 350px) {\n//   .env-store-add-product-heading{\n//     margin-left: 1rem;\n// }\n//   .round::after{\n//     content: \" \";\n//     display: block;\n//     margin-top: -18px;\n//     margin-right: 0;\n//     bottom: 1px;\n//     margin-left: 26px;\n//     height: 1px;\n//     width: 1px;\n//     transform: scale(14, 1);\n//     transform-origin: -36% 0;\n//     background-color: rgba(238, 58, 36, 0.1803921569);\n\n//   }\n// }\n// @media only screen and (min-width: 351px) and  (max-width: 375px) {\n//   .env-store-add-product-heading{\n//     margin-left: 1rem;\n// }\n//   .round::after{\n//     content: \" \";\n//     display: block;\n//     margin-top: -18px;\n//     margin-right: 0;\n//     bottom: 1px;\n//     margin-left: 26px;\n//     height: 1px;\n//     width: 1px;\n//     transform: scale(18, 1);\n//     transform-origin: -36% 0;\n//     background-color: rgba(238, 58, 36, 0.1803921569);\n\n//   }\n// }\n// @media only screen and (min-width: 376px) and  (max-width: 414px) {\n//   .env-store-add-product-heading{\n//     margin-left: 1rem;\n// }\n//   .round::after{\n//     content: \" \";\n//     display: block;\n//     margin-top: -18px;\n//     margin-right: 0;\n//     bottom: 1px;\n//     margin-left: 21px;\n//     height: 1px;\n//     width: 1px;\n//     transform: scale(30, 1);\n//     transform-origin: -36% 0;\n//     background-color: rgba(238, 58, 36, 0.1803921569);\n\n//   }\n// }\n// @media only screen and (min-width: 415px) and  (max-width: 455px) {\n//   .env-store-add-product-heading{\n//     margin-left: 0rem;\n// }\n//   .round::after{\n//     content: \" \";\n//     display: block;\n//     margin-top: -18px;\n//     margin-right: 0;\n//     bottom: 1px;\n//     margin-left: 14px;\n//     height: 1px;\n//     width: 1px;\n//     transform: scale(43, 1);\n//   transform-origin: -36% 0;\n//     background-color: rgba(238, 58, 36, 0.1803921569);\n\n//   }\n// }\n// @media only screen and (min-width: 456px) and  (max-width: 500px) {\n//   .env-store-add-product-heading{\n//     margin-left: 0rem;\n// }\n//   .round::after{\n//     content: \" \";\n//     display: block;\n//     margin-top: -18px;\n//     margin-right: 0;\n//     bottom: 1px;\n//     margin-left: 15px;\n//     height: 1px;\n//     width: 1px;\n//     transform: scale(50, 1);\n//   transform-origin: -36% 0;\n//     background-color: rgba(238, 58, 36, 0.1803921569);\n\n//   }\n// }\n\n// @media only screen and (min-width: 501px) and (max-width: 600px) {\n//   .env-store-add-product-heading{\n//     margin-left: 0rem;\n// }\n// .stepper{\n//   // width: fit-content;\n\n//   flex:0 1;\n//   justify-content: flex-start;\n// }\n// .round{\n\n//   position: relative;\n//   margin: 0 0 0 40px;\n//   left: -32px;\n// }\n//   .round::after{\n//     content: \" \";\n//     display: block;\n//     margin-top: -18px;\n//     margin-right: 0;\n//     bottom: 1px;\n//     margin-left: 17px;\n//     height: 1px;\n//     width: 1px;\n//     transform: scale(43, 1);\n//     transform-origin: -30% 0;\n//     background-color: rgba(238, 58, 36, 0.1803921569);\n\n//   }\n// }\n@media only screen and (min-width: 601px) {\n  .stepper {\n    flex: 0 1;\n    justify-content: flex-start;\n  }\n  .round {\n    position: relative;\n    margin: 0 0 0 54px;\n    left: -52px;\n  }\n  .round::after {\n    content: \" \";\n    display: block;\n    margin-top: -1.24875vw;\n    margin-right: 0;\n    bottom: 1px;\n    margin-left: 17px;\n    height: 1px;\n    width: 1px;\n    transform: scale(55, 1);\n    transform-origin: -30% 0;\n    background-color: rgba(238, 58, 36, 0.1803921569);\n  }\n}\n// @media only screen and (min-width: 476px) and  (max-width: 575px) {\n//   .inner-container{\n//       text-align: center;\n//       padding: 2.5rem 2.5rem;\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
